import object from 'helpers/object'


export const initialState = {
  drivers: {
    isFetching: false,
    headings: {
      left: [
        '№ авт.',
        '№',
        'ФИО',
        '№ Бр.',
      ],
      right: [],
    },
    values: {
      left: [],
      right: [],
    },
    pages: 0,
    activePageId: 1,
    limit: 20,
  },
  conductors: {
    isFetching: false,
    headings: {
      left: [
        '№ авт.',
        '№',
        'ФИО',
        '№ Бр.',
      ],
      right: [],
    },
    values: {
      left: [],
      right: [],
    },
    pages: 0,
    activePageId: 1,
    limit: 20,
  },
  buses: {
    isFetching: false,
    headings: {
      left: [
        'Гаражный №',
        // '№ авт.',
        // 'Марка',
      ],
      right: [],
    },
    values: {
      left: [],
      right: [],
    },
    pages: 0,
    activePageId: 1,
    limit: 20,
  },

  order: {
    isFetching: false,
    headings: {
      left: [
        'ФИО',
        '№', //'Табельный №',
        'Тип расписания',
        'Маршрут',
      ],
      right: [],
    },
    values: {
      left: [],
      right: [],
    },
    pages: 0,
    activePageId: 1,
    limit: 20,
  },

  report: {
    isFetching: false,
    headings: {
      left: [],
      right: [],
    },
    values: {
      left: [],
      right: [],
    },
    pages: 0,
    activePageId: 1,
    limit: 20,
  },

  codes: {},

  newOrder: {},
}


export const setList = (state, payload) =>
  object.setIn(state, [ payload.type, 'list' ], payload.list)

export const setValues = (state, payload) =>
  object.setIn(state, [ payload.type, 'values' ], payload.values)

export const setNewOrder = (state, payload) =>
  object.setIn(state, [ 'newOrder' ], payload)

export const setPages = (state, payload) =>
  object.setIn(state, [ payload.type, 'pages' ], payload.pages)

export const setHeadings = (state, payload) =>
  object.setIn(state, [ payload.type, 'headings', 'right' ], payload.headings)

export const setActivePageId = (state, payload) =>
  object.setIn(state, [ payload.type, 'activePageId' ], payload.activePageId)

export const setFetching = (state, payload) =>
  object.setIn(state, [ payload.type, 'isFetching' ], payload.isFetching)

export const setCodes = (state, payload) =>
  object.setIn(state, [ payload.type, 'codes' ], payload.data)